export const LEGACY_API_BASE_URL = 'https://fper0og975.execute-api.us-east-2.amazonaws.com/dev'
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://2iw11py2s9.execute-api.us-east-2.amazonaws.com/dev'